export default __webpack_public_path__ + "static/media/EnrollmentIcon.a685e670.svg";